export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20luxury%20apartment%20building%20at%20sunset%20with%20warm%20golden%20light%2C%20architectural%20photography%2C%20clean%20lines%2C%20glass%20facade%2C%20professional%20real%20estate%20visual%2C%20warm%20teal%20and%20gold%20tones%2C%20elegant%20urban%20residential%20complex%2C%20editorial%20quality&width=1600&height=900&seq=hero-2026-x1&orientation=landscape"
          alt="Imóveis modernos e elegantes"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 border border-primary-400/30 rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></span>
            <span className="text-sm font-medium text-primary-100">
              Soluções em crédito para seu imóvel
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Realize o sonho
            <br />
            da casa própria
          </h1>

          <p className="text-lg md:text-xl text-foreground-200 mb-8 max-w-xl leading-relaxed">
            Financiamento imobiliário, Home Equity e consórcio com as melhores
            taxas do mercado. Atendimento personalizado para você e sua família.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://wa.me/5511985860949"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Simule Agora
            </a>
            <a
              href="#servicos"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 text-white font-medium rounded-full border border-white/30 hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              Conheça Nossos Serviços
              <i className="ri-arrow-down-line text-lg"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-6 mt-12 pt-8 border-t border-white/20">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/30">
                <i className="ri-shield-check-line text-primary-300 text-lg"></i>
              </div>
              <div>
                <p className="text-white font-medium text-sm">Segurança</p>
                <p className="text-foreground-300 text-xs">Garantia em cada etapa</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/30">
                <i className="ri-percent-line text-primary-300 text-lg"></i>
              </div>
              <div>
                <p className="text-white font-medium text-sm">Melhores Taxas</p>
                <p className="text-foreground-300 text-xs">Condições especiais</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/30">
                <i className="ri-time-line text-primary-300 text-lg"></i>
              </div>
              <div>
                <p className="text-white font-medium text-sm">Aprovação Rápida</p>
                <p className="text-foreground-300 text-xs">Sem burocracia</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}